import _ from 'lodash';

import {
    getSearchFilterEntries,
    type SearchFilterEntry,
    unwrapSearchFilters,
} from '@/shared/components/filters/searchFilters';

export const getFiltersRowEntries = (
    filters: unknown,
    includeRoot: boolean,
    scopePaths: string[][],
): SearchFilterEntry[] => {
    const legacyFilters = unwrapSearchFilters(filters);
    const rootFilters = Object.fromEntries(Object.entries(legacyFilters).filter(([key]) => key !== 'searchDomains'));
    const rootFilterEntries = includeRoot ? getSearchFilterEntries(rootFilters) : [];
    const scopedFilterEntries = scopePaths.flatMap((scopePath) =>
        getSearchFilterEntries(_.get(legacyFilters, scopePath, {})).map((entry) => ({
            ...entry,
            path: [...scopePath, entry.path].join('.'),
        })),
    );

    return [...rootFilterEntries, ...scopedFilterEntries];
};
